<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          پیام های دریافتی
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.go(-1)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
<!--      <v-toolbar dense dark style="display: block"  color="#1e45c7" >-->
<!--        <v-toolbar-title>پیام های دریافتی</v-toolbar-title>-->
<!--        <v-spacer/>-->
<!--        <v-btn dark depressed small style="background-color: #be1e0b" icon @click="$router.go(-1)">-->
<!--          <v-icon >mdi-close</v-icon>-->
<!--        </v-btn>-->
<!--      </v-toolbar>-->
      <v-card-text>

        <v-row>

          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex">
            <v-text-field
                clearable
                @click:clear="fillDataItems"
                outlined
                dense
                placeholder="عنوان، نام مجتمع"
                v-model="searchvalue"
            />
            <v-btn  fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col  class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="3"
                ellipsis-text="..."
                @change="pageChangeHandler"
            />

          </v-col>
        </v-row>
        <div v-if="showMsg">
          <see-msg :model="model"  :showMsg.sync="showMsg"/>
        </div>
        <v-spacer/>
        <b-table
            v-if="can('messageList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(read)="row"   >
            <v-btn depressed small v-if="row.item.isRead" color="success">
              خوانده شده
            </v-btn>
            <v-btn depressed small v-if="!row.item.isRead" color="danger">
              خوانده نشده
            </v-btn>
          </template>

          <template #cell(actions)="row" >
            <v-btn depressed small  color="primary" @click="forSee(row.item.msgId)" class="mr-1 ">
              مشاهده
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteMessage')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SeeMsg from './SeeMsg'
import Message_se from "./Message_se";
import {mapMutations} from "vuex";


export default {
  name: 'Manager',
  components: {
    SeeMsg
  },

  data() {
    return {
      searchvalue: '',
      userType: '',
      modelId: '',
      data: {},
      model: {},
      modelAtributes: {},
      showDialog: false,
      showMsg: false,
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'title', label: 'عنوان', sortable: true, sortDirection: 'desc'},
        {key: 'dateText', label: 'تاریخ ارسال' },
        {key: 'buildingName', label: 'نام مجتمع'},
        {key: 'read', label: 'وضعیت'},
        {key: 'actions', label: 'عملیات'},
      ],

    };

  },

  mounted() {
    this.$root.$on('Message', () => {
      this.fillDataItems()
    })

  },

  methods: {

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    fetch() {
      Message_se.getById(this.modelId).then(response => {
        this.data = response.data
      })
      this.showDialog = true;
    },

    forSee: function (msgId) {
      this.modelId = msgId;
      this.showMsg=false
      Message_se.readMessage(this.modelId).then(res=>{
        this.model=res.data
      })
      this.showMsg=true
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Message_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      this.modelAtributes = (Message_se.getPageReceive(this.skip - 1, this.take,this.searchvalue).then(response => {
        this.modelAtributes = response.data
        this.userType = this.modelAtributes.userType
        this.paging = this.modelAtributes.page
        this.dataItems = this.modelAtributes.messageList

      }));
    },
    // search(){
    //   if(this.searchvalue.length>0){
    //     Message_se.searchReceive(this.searchvalue,this.skip-1, this.take).then(result=>{
    //       this.dataItems=result.data.messageList
    //       this.paging=result.data.page
    //     })
    //   }else if(this.searchvalue.length===0){
    //     this.fillDataItems()
    //   }
    // },

  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
